import { T } from "@/components/T";

export function FotoMosaik() {
  return (
    <section className="overflow-hidden" style={{ background: "#0b0c0e" }}>
      <div className="grid grid-cols-1 lg:grid-cols-3" style={{ gap: "2px" }}>
        <div className="lg:col-span-2 relative overflow-hidden group" style={{ height: "clamp(260px, 38vw, 500px)" }}>
          <img loading="lazy" src="/assets/fotos/hb-foto-7.webp" alt="Premium Holzterasse – Holzbuddy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            style={{ objectPosition: "center 55%" }} />
          <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-transparent to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
            <p className="text-[9px] tracking-widest uppercase font-semibold mb-1 font-inter" style={{ color: "rgba(245,200,0,0.7)" }}>
              <T de="Terrassen & Balkone" it="Terrazze & Balconi" />
            </p>
            <p className="font-bebas text-white leading-none" style={{ fontSize: "clamp(20px, 2.5vw, 30px)" }}>
              <T de="Premium-Finish. Bis ins letzte Detail." it="Finitura premium. Ogni dettaglio curato." />
            </p>
          </div>
        </div>
        <div className="flex flex-col" style={{ gap: "2px" }}>
          <div className="relative overflow-hidden group flex-1" style={{ minHeight: "clamp(130px, 19vw, 249px)" }}>
            <img loading="lazy" src="/assets/fotos/hb-foto-3-4.webp" alt="Holzschindeln Südtirol"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              style={{ objectPosition: "center" }} />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="text-[9px] tracking-widest uppercase text-white/50 font-semibold font-inter">
                <T de="Materialqualität" it="Qualità del materiale" />
              </p>
            </div>
          </div>
          <div className="relative overflow-hidden group flex-1" style={{ minHeight: "clamp(130px, 19vw, 249px)" }}>
            <img loading="lazy" src="/assets/fotos/hb-foto-9.webp" alt="Holzkonstruktion Innenraum – Holzbuddy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              style={{ objectPosition: "center" }} />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="text-[9px] tracking-widest uppercase text-white/50 font-semibold font-inter">
                <T de="Holzkonstruktion" it="Costruzione in legno" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
